'use client';

import Link from 'next/link';
import { COOKIE_POLICY_PATH } from '@/constants/legalRoutes';
import { useConsent } from './ConsentProvider';

export default function CookieBanner() {
  const { ready, state, acceptAll, rejectAll, openPreferences } = useConsent();

  if (!ready || state.hasResponded) {
    return null;
  }

  return (
    <div
      className="asst-cookie-banner"
      role="dialog"
      aria-modal="false"
      aria-labelledby="asst-cookie-banner-title"
      aria-describedby="asst-cookie-banner-desc"
    >
      <div className="container-xxl">
        <div className="asst-cookie-banner__inner">
          <div className="asst-cookie-banner__copy">
            <h2 id="asst-cookie-banner-title" className="asst-cookie-banner__title">
              Informativa sui cookie
            </h2>
            <p id="asst-cookie-banner-desc" className="asst-cookie-banner__text mb-0">
              Utilizziamo solo cookie tecnici necessari al funzionamento del sito.
              Contenuti di terze parti (ad esempio video e mappe) vengono caricati
              solo con il tuo consenso. Chiudere o ignorare questo avviso non
              equivale a un consenso.{' '}
              <Link prefetch={false} href={COOKIE_POLICY_PATH} className="asst-cookie-banner__policy-link">
                Cookie policy
              </Link>
            </p>
          </div>
          <div className="asst-cookie-banner__actions">
            <button
              type="button"
              className="btn btn-primary asst-cookie-banner__btn"
              onClick={rejectAll}
            >
              Rifiuta tutti
            </button>
            <button
              type="button"
              className="btn btn-primary asst-cookie-banner__btn"
              onClick={openPreferences}
            >
              Personalizza
            </button>
            <button
              type="button"
              className="btn btn-primary asst-cookie-banner__btn"
              onClick={acceptAll}
            >
              Accetta tutti
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
